import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import StagesManager from "../../components/StagesManager";
import { checkTranslation, chooseFontColor, conditionalWidth, imageAddress, pathMaker, translate } from "../../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../../components/PageStatusViewer";
import { HubSettings, MainSettings, SettingsPages } from "../../variables/AppletPages";
import CommingSoon from "./CommingSoon";
import SettingsGeneral from "./settings/SettingsGeneral";
import HttpServices from "../../utils/Http.services";
import Responsive from "../../components/Responsive";
import Header from "../../components/header/Header";
import BaseAdminView from "./BaseAdminView";
import ViewBlog from "./database/ViewBlog";


class SettingsApplet extends Component {

    state = {
        modules: [],
        showBackBtn: false,
        showToolbar: true,
        bg: 'linear-gradient(90deg, #0cebeb, #29ffc6)',
        bg2: ' rgba(32, 5, 66, 0.1)',

        colors: {
            // primaryColor: '#cc1d65',
            // secondaryColor: '#b01a58',
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        },
        defaultHeaderConfig: { showToolbar: true, showSettings: false, showFrames: 'static' }
    }


    componentDidMount() {
        // console.log('baseurlllllSettingsApplet', this.props.user.info)
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        let frames = Object.values(HubSettings.pages)
        let framesSections = Object.values(HubSettings.sections)

        this.setState({ frames, framesSections })


    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.checkDefaultTab()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                // let accessPages = Object.values(MainSettings.pages)
                // let accessSections = Object.values(MainSettings.sections)
                let accessPages = Object.values(HubSettings.pages)
                let accessSections = Object.values(HubSettings.sections)


                this.setState({ accessPages, accessSections }, () => {
                    // this.checkDefaultTab()
                    // this.fetchSettings()

                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)

                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'SettingsApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    componentDidUpdate(prevProps) {
        // if ((this.state.oldData && this.state.oldData != this.props.windowData) || this.props.width != prevProps.width) {
        //     this.setState({ oldData: this.props.windowData }, () => {
        //         this.checkDefaultTab()
        //     })
        // }
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }



    // fetchSettings() {
    //     let targetHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub._id : this.props.applet?.hub
    //     let body = { targetHub }
    //     HttpServices.request('getProfileSettings', body, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingPage: false })
    //         if (fetchError) {
    //             this.setState({ pageStatus: 404 })
    //             return
    //         }
    //         this.setState({ pageStatus: 200, profile: fetchResult.info }, () => {
    //             this.stageManager.changeStage(this.state.pageType, () => {
    //                 window.scrollTo({ top: 0, behavior: 'smooth' })
    //             })
    //         })
    //     })
    // }


    settingsUpdated = (info) => {
        this.setState({ profile: info }, () => {
            this.props.actions.updatePage(info)
            this.props.userUpdated(info)
        })
    }


    checkDefaultTab() {
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }



    changePage = (page) => {
        let path
        if (page) {
            path = [page?.key ?? page]
        }
        this.props.changeWindowLink(path)

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }


    render() {

        let variables = {
            appletId: this.props.applet?._id,
            appletHub: this.props.applet?.hub,
            targetId: this.props.applet?.hub,
            targetHub: this.props.applet?.hub,
            hub: this.props.applet?.hub,
            user: this.props.applet?.hub,


        }
        let colors = this.state.colors ?? {}
        // console.log('ddddddddddddd', this.props.user.info)
        let applet = this.props.applet
        if (applet?.hub?.colorType != 'default' && applet?.hub?.colors) {
            colors = applet?.hub.colors
        }

        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors ?? {}
        }

        if (!colors?.textColor) {
            // console.log('this.state.colors',colors)
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // return (

        //     <div className="h-100 scroll-no-scrollbar window-content-radius">
        //         <PageStatusViewer setData={this.setData} status={this.state.pageStatus}>
        //             <div className=" w-100 h-100 ">
        //                 <div className='w-100 h-100 '>

        //                     {/* {(conditionalWidth(this.props.width, { xs: false, sm: true }) || !this.state.page) && (
        //                         <Responsive height="100%" width={this.props.width} media={{ xs: "12", sm: '4', md: '4', lg: "3", xl: "3" }}>
        //                             <div className='scroll-no-scrollbar h-100 pt-3 pb-4 w-100 d-flex flex-column' >
        //                                 <div>
        //                                     <div onClick={() => this.props.goToHub()} className='flexc pb-3 px-3 cursor-pointer' style={{ borderBottom: '1px solid #eee' }}>
        //                                         <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="50px" style={{ height: 50, objectFit: 'cover', borderRadius: 100 }} />
        //                                         <div className='mld-2'>
        //                                             <h2 className="m-0 text-normal mb-0" >{checkTranslation(this.props.applet?.hub?.fullname)}</h2>
        //                                             <div style={{ maxWidth: 450 }}>
        //                                                 <p className="mt-0 text-small color-gray-1" >{translate('Settings')}</p>
        //                                             </div>
        //                                         </div>
        //                                     </div>

        //                                     <div className=' w-100 '>
        //                                         {this.state.sections?.map((section, i) => {
        //                                             return (
        //                                                 <div className="w-100" style={{ borderBottom: '1px solid #e8e8e8' }}>

        //                                                     {this.state.modules.map((item, index) => {
        //                                                         if (section.key == item.section)
        //                                                             return (
        //                                                                 <div className='w-100 ' key={index}>
        //                                                                     <div onClick={() => this.changePage(item)} className='flexc w-100 pb-3 pt-3 px-3 cursor-pointer transition-all' style={{ backgroundColor: this.state.page?.key == item.key ? '#eee' : '' }}>
        //                                                                         <div className='flexcc'>
        //                                                                             <img className="transition-all" src={item.icon} height={22} style={{ filter: this.state.page?.key == item.key ? '' : 'saturate(0%)' }} />
        //                                                                         </div>
        //                                                                         <div className='d-flex flex-column mld-3'>
        //                                                                             <p className={'text-semibold text-small text-capitalize ' + (this.state.page?.key == item.key ? "" : "color-gray-3")}>{checkTranslation(item.title)}</p>
        //                                                                         </div>
        //                                                                     </div>
        //                                                                 </div>
        //                                                             )
        //                                                     })}

        //                                                 </div>
        //                                             )
        //                                         })}

        //                                         <div className="text-smaller px-3 pt-3">
        //                                             <p className="color-gray-3">{translate("Your-hub-is-supported-by-Yonnect")}</p>
        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                         </Responsive>
        //                     )} */}
        //                     <div style={{ position: 'sticky', top: 0, index: '99' }}>
        //                         <Header type={'static'} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} color={this.state.bg} color2={this.state.bg2} toolbar={this.state.showToolbar} />
        //                     </div>

        //                     {/* {(conditionalWidth(this.props.width, { xs: false, sm: true }) || this.state.page) && ( */}

        //                     <div className="w-100 window-content-radius h-100" ref={el => this.pageContainer = el}  >
        //                         <StagesManager ref={el => this.stageManager = el} fast={true}  >
        //                             <SettingsGeneral setData={this.setData} stageName={'settings-general'} applet={this.props.applet} initData={this.state.profile} width={this.props.width} settingsUpdated={this.settingsUpdated} pages={this.state.pages} pageType={this.state.pageType} changePage={this.changePage} page={this.state.page} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
        //                             <CommingSoon setData={this.setData} stageName={'table'} applet={this.props.applet} pages={this.state.pages} pageType={this.state.pageType} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changePage={this.changePage} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
        //                         </StagesManager>
        //                     </div>

        //                     {/* )} */}
        //                 </div>
        //             </div>
        //         </PageStatusViewer>
        //     </div>
        // )
        return (
            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <BaseAdminView permissionLevel='applet' stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} defaultHeaderConfig={this.state.defaultHeaderConfig} accessPages={this.state.accessPages} accessSections={this.state.accessSections} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} addNewWindow={this.props.addNewWindow} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} appletAccess={this.props.appletAccess} setData={this.setData} />
                    {/* <ViewBlog stageName={''} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} language={this.props.language} colors={colors} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} /> */}
                    {/* <DatabaseAdminView stageName={''} baseUrl={[...this.props.baseUrl]} language={this.props.language} removeWindowLink={this.props.removeWindowLink} width={this.props.width} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} /> */}

                </StagesManager>

            </div>
            // <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
            //     <p>sdfghjk</p>
            //     <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

            //         <BaseAdminView stageName={'admin'} baseUrl={[...this.props.baseUrl]} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} />
            //     </StagesManager>

            // </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsApplet);
